module.exports = __webpack_public_path__ + "static/media/AddWmsPanel.7362dac5.less";